import { render, staticRenderFns } from "./design_description.vue.js?vue&type=template&id=08b077c4&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_description.vue?vue&type=template&id=08b077c4&vue3"
import script from "./design_description.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_description.vue?vue&type=script&lang=js&vue3"
export * from "./design_description.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_description.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports